import React, { FC, memo } from "react";

import { Container, ContainerAlias, ContainerValue } from "./styled";
import { ExpandableTitle } from "../components/ExpandableTitle/ExpandableTitle";
import { isVisibleContainer } from "../utils/isVisibleContainer";
import { useWidgetContext } from "../../Dashboard/hooks/useWidgetContext";
import { ContainerProps } from "../types";

export const CameraContainer: FC<ContainerProps> = memo(({ elementConfig, type, renderElement }) => {
  const { expandedContainers } = useWidgetContext(type);

  const { id, options } = elementConfig || {};
  const { expandable, expanded } = options || {};
  const isVisible = isVisibleContainer(id, expandable, expanded, expandedContainers);

  return (
    <>
      <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={renderElement} />
      {isVisible && (
        <Container style={elementConfig?.style}>
          <ContainerAlias hasBottomMargin>{renderElement({ id: "alias" })}</ContainerAlias>
          <ContainerValue>{renderElement({ id: "value", wrap: false })}</ContainerValue>
        </Container>
      )}
    </>
  );
});
